<template>
    <div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{path:'/dashboard'}">Inicio</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Pagos de Jugadores</li>
                        </ol>
                    </nav>
                </div>


                <div class="col-md-12" style="margin-bottom: 20px">

                    <div class="row">
                        <div class="col-md-3">
                            <label for="mes"><strong>Seleccione hora</strong></label>
                            <select class="form-control" v-model="horaId" @change="loadPlayers">
                                <option :value="{sede: 1, hora: 1, dia: 1}">Todas</option>
                                <option v-for="hora in horas" :value="hora">
                                    {{ hora.sede + ' - ' + hora.dia + ' - ' + hora.hora }}
                                </option>
                            </select>
                        </div>

                        <div class="col-md-3">
                            <label for="mes"><strong>Seleccione mes</strong></label>
                            <select name="mes" id="mes" class="form-control" v-model="mes" @change="loadPlayers">
                                <option value="0">Octubre</option>
                                <option value="1">Noviembre</option>
                                <option value="2">Diciembre</option>
                                <option value="3">Enero</option>
                                <option value="4">Febrero</option>
                                <option value="5">Marzo</option>
                                <option value="6">Abril</option>
                                <option value="7">Mayo</option>
                                <option value="8">Junio</option>
                            </select>
                        </div>


                        <div class="col-md-3">
                            <label for="cuotaMatricula"><strong>Cuota matricula</strong></label>
                            <select name="cuotaMatricula" id="cuotaMatricula" class="form-control"
                                    v-model="cuotaMatricula">
                                <option value="20">Nuevos - 20 €</option>
                                <option value="10">Antiguos - 10 €</option>
                                <option value="0">0 €</option>
                            </select>
                        </div>

                        <div class="col-md-3">
                            <label for="cuotaMatricula"><strong>Seleccione fecha</strong></label>
                            <base-input
                                addon-left-icon="ni ni-calendar-grid-58"
                                style="margin-bottom: 0px">
                                <flat-picker slot-scope="{focus, blur}"
                                             @on-open="focus"
                                             @on-close="blur"
                                             :config="configDate"
                                             class="form-control datepicker"
                                             v-model="date">
                                </flat-picker>
                            </base-input>
                        </div>

                        <div class="col-md-3" style="margin-top: 30px">
                            <label for="matriculaPaid"><strong>Matrícula pagada</strong></label>
                            <select name="matriculaPaid" id="matriculaPaid" class="form-control"
                                    v-model="matriculaPaid" @change="loadPlayers">
                                <option value=99>Todos</option>
                                <option value=1>Si</option>
                                <option value=0>No</option>
                            </select>
                        </div>

                        <div class="col-md-3" style="margin-top: 30px">
                            <label for="mesPaid"><strong>Mes pagado</strong></label>
                            <select name="mesPaid" id="mesPaid" class="form-control"
                                    v-model="mesPaid" @change="loadPlayers">
                                <option value=99>Todos</option>
                                <option value=1>Si</option>
                                <option value=0>No</option>
                            </select>
                        </div>

                        <!--                        <div class="col-md-2">-->
                        <!--                            <br>-->
                        <!--                            <router-link :to="{path:'/admin/pagos-general'}">-->
                        <!--                                <button class="btn btn-sm btn-success">Vista general</button>-->
                        <!--                            </router-link>-->
                        <!--                        </div>-->
                    </div>

                    <div class="card" style="margin-top: 20px;">
                        <div class="table-responsive">
                            <table class="table table-bordered table-sm text-nowrap" id="table-players">
                                <thead class="table-dark">
                                <tr>
                                    <th></th>
                                    <th>Nombre</th>
                                    <th>Posicion</th>
                                    <th>Sede</th>
                                    <th>Día</th>
                                    <th>Matricula</th>
                                    <th colspan="4">{{ mes | parseMesPago }}</th>
                                    <th></th>
                                    <th></th>
                                </tr>
                                </thead>

                                <tbody>
                                <tr v-for="player in players">
                                    <th style="width: 50px">
                                        <button class="btn btn-sm"
                                                :class="{'btn-warning':player.comentario, 'btn-default':!player.comentario}"
                                                v-b-tooltip.hover.top
                                                :title="player.comentario"
                                                @click="openModalComentario(player)"
                                        ><i class="fa fa-pen"></i>
                                        </button>
                                    </th>
                                    <th style="vertical-align: middle">
                                        <router-link :to="{path: '/jugadores/'+player.id}">
                                                    <span class="name mb-0 text-sm"
                                                          id="name-player">{{
                                                            player.apellidos | capitalizeText
                                                        }}, {{ player.nombre | capitalizeText }} </span>
                                        </router-link>
                                    </th>
                                    <td v-if="player.posicion != 'Portero'" class="text-center"
                                        style="vertical-align: middle;">
                                        <span>JUGADOR</span>
                                    </td>
                                    <td v-else style="background-color: #76eea7; vertical-align: middle;"
                                        class="text-center">
                                        <span>PORTERO</span>
                                    </td>
                                    <td class="text-center" style="vertical-align: middle;">{{
                                            player.sede |
                                                parseSedePago
                                        }}
                                    </td>
                                    <td class="text-center" style="vertical-align: middle;">{{
                                            player.dia |
                                                parseDiaPago
                                        }}
                                    </td>
                                    <td v-if="player.matricula" class="text-center"
                                        style="cursor: pointer; vertical-align: middle;"
                                        @click="changeMatricula(player, 0)">
                                        <span>OK</span>
                                    </td>
                                    <td v-else
                                        style="background-color: #fb6340; cursor: pointer; vertical-align: middle;"
                                        class="text-center"
                                        @click="openModalMatricula(player)">
                                        <span>NP</span>
                                    </td>


                                    <td v-for="(pay, index) in player.pays" :class="{'pagado': player.pagado }"
                                        style="width: 150px; text-align: center">
                                        <button class="btn btn-info btn-sm"
                                                @click="changeDiaEntreno(player.id, pay)"
                                                v-if="pay.dia_entreno === ''">Día {{ parseInt(index) }}
                                        </button>
                                        <input type="text" class="form-control form-control-sm"
                                               v-model="pay.dia_entreno"
                                               @blur="changeDiaEntreno(player.id, pay)" v-else>
                                    </td>

                                    <td style="text-align: center">
                                        <button class="btn btn-sm btn-success" v-if="!player.pagado"
                                                @click="openModalPagarMes(player, 1, 'full')">
                                            <i class="fas fa-euro-sign"></i>
                                        </button>
                                        <button class="btn btn-sm btn-warning" v-else
                                                @click="pagarMes(player, 0, '')">
                                            <i class="fas fa-euro-sign"></i>
                                        </button>

                                        <button class="btn btn-sm btn-success" v-if="!player.pagado"
                                                @click="openModalPagarMes(player, 1, 'half')">
                                            <i class="fas fa-euro-sign"></i> / 2
                                        </button>

                                        <button class="btn btn-sm btn-success" v-if="!player.pagado"
                                                @click="openModalPagarMes(player, 1, 'zero')">
                                            <i class="fas fa-euro-sign"></i> 0
                                        </button>
                                    </td>

                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <modal :show.sync="modalEditComentario">
            <template slot="header">
                <h4 class="modal-title" id="exampleModalLabel">Editar comentario</h4>
            </template>
            <div>
                <div class="row">
                    <div class="col-md-12" style="margin-bottom: 20px">
                        <label><strong>Comentario</strong></label>
                        <input type="text" class="form-control" v-model="modal.comentario">
                    </div>
                </div>
            </div>
            <template slot="footer">
                <base-button type="secondary" @click="modalEditComentario = false">Cerrar</base-button>
                <base-button type="primary" @click="editarComentario(modal.player)">Guardar</base-button>
            </template>
        </modal>

        <modal :show.sync="modalPagarMes">
            <template slot="header">
                <h4 class="modal-title" id="exampleModalLabel">Marcar mes como pagado</h4>
            </template>
            <div>
                <div class="row">
                    <div class="col-md-12" style="margin-bottom: 20px">
                        <label><strong>Seleccionar dia</strong></label>
                        <base-input
                            addon-left-icon="ni ni-calendar-grid-58"
                            style="margin-bottom: 0px">
                            <flat-picker slot-scope="{focus, blur}"
                                         @on-open="focus"
                                         @on-close="blur"
                                         :config="configDate"
                                         class="form-control datepicker"
                                         v-model="modalPagarMesData.date">
                            </flat-picker>
                        </base-input>
                    </div>
                </div>
            </div>
            <template slot="footer">
                <base-button type="secondary" @click="modalPagarMes = false">Cerrar</base-button>
                <base-button type="primary"
                             @click="pagarMes(modalPagarMesData.player, modalPagarMesData.sino, modalPagarMesData.option)">
                    Guardar
                </base-button>
            </template>
        </modal>

        <modal :show.sync="modalPagarMatricula">
            <template slot="header">
                <h4 class="modal-title" id="exampleModalLabel">Marcar matricula como pagada</h4>
            </template>
            <div>
                <div class="row">
                    <div class="col-md-12" style="margin-bottom: 20px">
                        <label><strong>Seleccionar dia</strong></label>
                        <base-input
                            addon-left-icon="ni ni-calendar-grid-58"
                            style="margin-bottom: 0px">
                            <flat-picker slot-scope="{focus, blur}"
                                         @on-open="focus"
                                         @on-close="blur"
                                         :config="configDate"
                                         class="form-control datepicker"
                                         v-model="modalPagarMatriculaData.date">
                            </flat-picker>
                        </base-input>
                    </div>
                </div>
            </div>
            <template slot="footer">
                <base-button type="secondary" @click="modalPagarMatricula = false">Cerrar</base-button>
                <base-button type="primary"
                             @click="changeMatricula(modalPagarMatriculaData.player, 1)">
                    Guardar
                </base-button>
            </template>
        </modal>
    </div>
</template>
<script>
import axios from 'axios';
import swal from 'sweetalert2'
import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'
import flatPicker from "vue-flatpickr-component";
import {Spanish} from 'flatpickr/dist/l10n/es'
import "flatpickr/dist/flatpickr.css";


export default {
    data() {
        return {
            horas: [],
            horaId: {
                hora: this.$route.params.horaId,
                sede: this.$route.params.sedeId,
                dia: this.$route.params.diaId,
            },
            players: [],
            mes: 0,
            cuota: 40,
            cuotaMatricula: 20,
            modalEditComentario: false,
            modalPagarMes: false,
            modalPagarMatricula: false,
            matriculaPaid: 99,
            mesPaid: 99,
            modal: {
                player: null,
                comentario: ""
            },
            modalPagarMesData: {
                player: null,
                sino: null,
                option: null,
                date: 'today'
            },
            modalPagarMatriculaData: {
                player: null,
                date: 'today'
            },
            date: "today",
            configDate: {
                allowInput: false,
                altFormat: 'd-m-Y',
                altInput: true,
                dateFormat: 'Y-m-d',
                locale: Spanish
            },
        };
    },
    components: {flatPicker},
    directives: {
        'b-tooltip': BTooltipDirective
    },
    created() {
        this.loadHoras();
    },
    methods: {
        loadHoras() {
            this.players = [];
            let vm = this;
            axios.get(this.$store.getters.apiUrl + 'horas-pagos', {
                params: {
                    jwt: vm.$store.getters.jwt,
                    mes: vm.mes,
                    season: vm.$store.getters.season
                }
            }).then(response => {
                if (response.data.response) {
                    vm.horas = response.data.result;
                    vm.loadPlayers();
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        loadPlayers() {
            this.players = [];
            let vm = this;
            axios.get(this.$store.getters.apiUrl + 'players-pagos', {
                params: {
                    jwt: vm.$store.getters.jwt,
                    mes: vm.mes,
                    season: vm.$store.getters.season,
                    horaId: vm.horaId.hora,
                    sedeId: vm.horaId.sede,
                    diaId: vm.horaId.dia,
                    matriculaPaid: vm.matriculaPaid,
                    mesPaid: vm.mesPaid
                }
            }).then(response => {
                if (response.data.response) {
                    vm.players = response.data.result;
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        changeMatricula(player, matricula) {
            player.matricula = matricula;
            let vm = this;
            axios.post(this.$store.getters.apiUrl + 'players/' + player.id + '/change-matricula', {
                idPlayer: player.id,
                matricula: matricula,
                cuotaMatricula: this.cuotaMatricula,
                date: this.modalPagarMatriculaData.date,
                jwt: this.$store.getters.jwt,
                season: vm.$store.getters.season
            }).then(response => {
                if (response.data.response) {
                    if(matricula === 1){
                        this.modalPagarMatricula = false;
                    }
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        pagarMes(player, sino, option) {
            player.pagado = sino;
            let vm = this;
            axios.post(this.$store.getters.apiUrl + 'players/' + player.id + '/pagar-mes', {
                idPlayer: player.id,
                mes: vm.mes,
                sino: sino,
                cuota: vm.cuota,
                date: vm.modalPagarMesData.date,
                jwt: this.$store.getters.jwt,
                season: vm.$store.getters.season,
                option: option
            }).then(response => {
                if (response.data.response) {
                    this.modalPagarMes = false;
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        openModalComentario(player) {
            this.modal.player = player;
            this.modal.comentario = player.comentario;
            this.modalEditComentario = true;
        },
        openModalPagarMes(player, sino, option) {
            this.modalPagarMesData.player = player;
            this.modalPagarMesData.sino = sino;
            this.modalPagarMesData.option = option;
            this.modalPagarMes = true;
        },
        openModalMatricula(player) {
            this.modalPagarMatriculaData.player = player;
            this.modalPagarMatricula = true;
        },
        editarComentario(player) {
            player.comentario = this.modal.comentario;
            let vm = this;
            axios.post(this.$store.getters.apiUrl + 'players/' + player.id + '/editar-comentario', {
                idPlayer: player.id,
                comentario: vm.modal.comentario,
                jwt: this.$store.getters.jwt
            }).then(response => {
                if (response.data.response) {
                    vm.modalEditComentario = false;
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        changeDiaEntreno(idPlayer, pay) {
            let vm = this;
            axios.post(this.$store.getters.apiUrl + 'players/' + idPlayer + '/change-dia-entreno', {
                idPlayer: idPlayer,
                pay: pay,
                jwt: this.$store.getters.jwt
            }).then(response => {
                if (response.data.response) {
                    pay.dia_entreno = response.data.message;
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
    }

};
</script>
<style scoped>

.container-fluid {
    margin-top: 39px;
}

.card {
    background-color: #f7fafc !important;
    box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.30) !important;
    border: 1px solid rgba(0, 0, 0, .05);
    border-radius: .375rem;
}

#table-players tbody tr:hover {
    background-color: rgba(62, 92, 75, 0.3);
}

td, th {
    padding-left: 10px !important;
    padding-right: 10px !important;
}

.pagado {
    background-color: #1fa2ff;
}

.comentario {
    cursor: pointer;
    background-color: #fb6340;
}

</style>
